import React from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';
import Swal from 'sweetalert2';
import { Table, OverlayTrigger, ButtonToolbar, Tooltip, Badge } from "react-bootstrap";
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createBrowserHistory } from 'history';
import Pagination from "react-js-pagination";
import { SummaryCategory, DeleteCategory, UpdateCategoryStatus } from '../../crud/faq';
require("bootstrap/scss/bootstrap.scss");

const history =  createBrowserHistory();

export default class FAQ extends React.Component {
  historyEdit(id) {
    history.push("/leaderboard/"+id+"/editEvent");
    window.location.reload();
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingListData: false,
      loadingModal: false,
      totalData: 0,
      data:[],
      dataDetail: {},
      postPerPage: 15,
      seacrhParams: '',
      orderBy: '',
      orderSort: 'asc',
      active: 1,
      dataDropdown: [],
      dropdown: '',
      status: '',
    }
  }

  handlePageChange = (pageNumber) => {
    let activePage = pageNumber
    this.setState({
      active: activePage
    }, () => {
      this.getSummary(activePage);
    })
  }

  dateTime = date => {
    var date1 = date
    var fmtDate = moment(date1).format('DD-MM-YY hh:m A');

    return fmtDate
  }

  getToken(){
    let token = localStorage.getItem("token")
    return token;
  }

  getSummary(pages = 1) {
    this.setState({
      loading: true
    })

    let stat = '';
    if(this.state.status !== '') stat=`&status=${this.state.status}`;
    let categories = '';
    if(this.state.dropdown !== '') categories=`&id_faq_category=${this.state.dropdown}`;

    let params = '';
    if(this.state.orderBy !== ''){
      params = `?order_by=${this.state.orderBy}&order_sort=${this.state.orderSort}&page=${pages}&limit=${this.state.postPerPage}&title=${this.state.seacrhParams}${stat}${categories}`
    }else{
      params = `?order_sort=${this.state.orderSort}&page=${pages}&limit=${this.state.postPerPage}&title=${this.state.seacrhParams}${stat}${categories}`
    }

    SummaryCategory(this.getToken(), params)
    .then(res => {
      this.setState({
        totalData: res.data.data.total_data,
        data: res.data.data.data,
        postPerPage: res.data.data.per_page,
        loading: false,
      })
    })
    .catch(e => {
      console.log(e);
      this.setState({
        data:[],
        loading: true
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  componentDidMount(){
    this.getSummary(this.state.active);
  }

  changeSearch = (event) => {
    this.setState({ seacrhParams: event.target.value, active: 1 });
  }

  handleAlert(id, status = 'delete'){
    Swal.fire({
      title: 'Are you sure?',
      text: status === 'delete' ? "You won't be able to revert this!" : "You change this status ?",
      icon: status === 'delete' ? 'warning' : 'info',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: status === 'delete' ? 'Yes, delete it!' : 'Submit'
    }).then((result) => {
      if (result.isConfirmed) {
        status === 'delete' ? this.delete(id) : this.updateStatus(id);
      }
    })
  }

  updateStatus(id) {
    this.setState({
      loading: true
    })

    UpdateCategoryStatus(this.getToken(), id)
    .then(res => {
      this.setState({
        loading: false,
      })
      this.getSummary(this.state.active);
    })
    .catch(e => {
      console.log(e);
      this.setState({
        loading: false
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  delete(id) {
    this.setState({
      loading: true
    })

    DeleteCategory(this.getToken(), id)
    .then(res => {
      this.setState({
        loading: false,
      })
      this.getSummary(this.state.active);
    })
    .catch(e => {
      console.log(e);
      this.setState({
        loading: true
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  searchFunction = () => {
    this.getSummary(1);
    this.setState({ active: 1 });
  }

  render(){
    const statusFaq = [
      {
        value: '',
        label : 'All'
      },
      {
        value: 0,
        label : 'Enable'
      },
      {
        value: 1,
        label : 'Disabled'
      }
    ]
    return (
      <div className="head" style={{fontSize: '10px'}}>
        <div className="kt-portlet">
          <div className="kt-portlet__body">
            <div className="kt-portlet__preview">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-start">
                  <input 
                    type="text" 
                    className="form-control mr-3" 
                    name="search" 
                    placeholder="Search" 
                    value={this.state.seacrhParams} 
                    onChange={this.changeSearch} />
                  <select className="custom-select custom-30 costume-dropdown mr-3" onChange={(e) => this.setState({status: e.target.value})} placeholder="Select Category" required>
                    <option disabled selected={this.state.status === null || this.state.status === '' ? true : false}>Select Status</option>
                    {statusFaq.map((e) => (
                      <option key={e.value} value={e.value} selected={e.value === this.state.status ? true : false} defaultValue={e.value === this.state.status ? true : false}>{e.label}</option>
                    ))}
                  </select>
                  <button className="btn btn-success btn-sm pr-5 pl-5 mr-3" type="button" onClick={() => this.searchFunction()}>Search</button>
                  <Link to="/faq/category-faq/add" style={{width: '30%', marginRight: '1rem'}}>
                    <button className="btn btn-primary btn-sm mr-3" type="button" style={{width: '100%', padding: '10px'}}>Add New Category</button>
                  </Link>
                  <Link to="/faq" style={{width: '20%', marginRight: '1rem'}}>
                    <button className="btn btn-warning btn-sm mr-3" type="button" style={{width: '100%', padding: '10px'}}>Back to FAQ</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="kt-portlet">
          <div className="kt-portlet__body pddlessForce">
            <div className="kt-portlet__preview">
              <div className="kt-section">
              <Table striped responsive>
                  <thead>
                    <tr>
                      <th className="tableheh" style={{ width: '4%' }}>
                        No
                      </th>
                      <th className="tableheh">
                        Category
                      </th>
                      <th className="tableheh center">
                        Status
                      </th>
                      <th className="tableheh">
                        Created At
                      </th>
                      <th className="tableheh">
                        Modified At
                      </th>
                      <th className="center tableheh" style={{width: '10%'}}>Action</th>
                    </tr>
                  </thead>
                  {this.state.loading ? 
                    <tbody>
                      <tr>
                        <td className="center" colSpan="8"><ReactLoading style={{position: 'relative', left: '50%', fill: 'rgb(88, 103, 221)', height: '5%', width: '5%'}} type={'bars'} color={'#5867dd'} height={'5%'} width={'5%'} /></td>
                      </tr>
                    </tbody> :
                    <tbody>
                      {this.state.data.map((row, index) => (
                        <tr key={index}>
                          <td>{index+1}</td>
                          <td>{row.title_en} / {row.title_id}</td>
                          <td className="center">
                            {row.status === 0 ?
                              <Badge variant="success" className="pointers" onClick={() => this.handleAlert(row.id, 'update')}>Enable</Badge>
                              :
                              <Badge variant="danger" className="pointers" onClick={() => this.handleAlert(row.id, 'update')}>Disabled</Badge>}
                          </td>
                          <td>{this.dateTime(row.created_at)}</td>
                          <td>{this.dateTime(row.updated_at)}</td>
                          <td>
                            <ButtonToolbar style={{ justifyContent: 'center'}}>
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Edit Data
                                  </Tooltip>
                                }
                              >
                                <Link to={`/faq/category-faq/${row.id}/update`} style={{width: '17%'}}>
                                  <span className="btn-action">
                                    <i style={{fontSize: '1rem', paddingRight: '0'}} className="fas fa-pencil-alt text-info" />
                                  </span>
                                </Link>
                              </OverlayTrigger>
                              &nbsp; | &nbsp;
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Delete Data
                                  </Tooltip>
                                }
                              >
                                <span className="btn-action" onClick={() => this.handleAlert(row.id)}>
                                  <i style={{fontSize: '1rem', paddingRight: '0'}} className="fas fa-trash-alt text-danger" />
                                </span>
                              </OverlayTrigger>
                            </ButtonToolbar>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  }
                </Table>
                <div className="d-flex justify-content-center align-items-center pagination-data">
                  <Pagination
                    activePage={this.state.active}
                    itemsCountPerPage={this.state.postPerPage}
                    itemClass="page-item"
                    linkClass="page-link"
                    totalItemsCount={this.state.totalData}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}